import {
  GET_FILTERS_SORTING_REQUEST,
  GET_FILTERS_SORTING_SUCCESS,
  GET_FILTERS_SORTING_FAILURE
} from 'Store/constants';

const initialState = {
  sortingOptions: { data: [], tabType: null },
  filterTabs: [],
  filterTabsByTabType: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FILTERS_SORTING_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case GET_FILTERS_SORTING_SUCCESS: {
      const { sortingOptions, filterTabs } = action.payload;
      const tabType = sortingOptions?.tabType;

      return {
        ...state,
        isLoading: false,
        sortingOptions,
        filterTabs,
        filterTabsByTabType: {
          ...state.filterTabsByTabType,
          [tabType]: filterTabs,
        },
        error: null
      };
    }

    case GET_FILTERS_SORTING_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    default:
      return state;
  }
};